import { combineReducers } from "redux";
import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import pincode from "../features/admin/masters/pincode/Slice";
import orientation from "../features/admin/masters/orientation/Slice";
import printinglocations from "../features/admin/masters/printing-locations/Slice";
import materials from "../features/admin/masters/materials/Slice";
import laminations from "../features/admin/masters/laminations/Slice";
import shapes from "../features/admin/masters/shapes/Slice";
import partners from "../features/admin/masters/partners/Slice";
import qty from "../features/admin/masters/qty/Slice";
import envelopes from "../features/admin/masters/envelopes/Slice";
import whychooseus from "../features/admin/masters/whychooseus/Slice";
import industry from "../features/admin/masters/industry/Slice";
import department from "../features/admin/masters/department/Slice";
import companysize from "../features/admin/masters/companysize/Slice";
import faqs from "../features/admin/masters/faqs/Slice";
import subfaqSlice  from "../features/admin/masters/subfaq/subfaqSlice";
import socialmedia from "../features/admin/masters/socialmedia/Slice";
import coupons from "../features/admin/masters/coupons/Slice";
import privacyandpolicy from "../features/admin/masters/privacyandpolicy/Slice";
import returnpolicy from "../features/admin/masters/returnpolicy/Slice";
import termsandconditions from "../features/admin/masters/termsandconditions/Slice";
import careers from "../features/admin/masters/careers/Slice";
import blog_categories from "../features/admin/masters/blog_categories/Slice";
import blogs from "../features/admin/masters/blogs/Slice";
import sizes from "../features/admin/masters/sizes/Slice";
import help  from "../features/admin/masters/help/Slice";

const masters = combineReducers({
  country: country,
  state: state,
  city: city,
  pincode: pincode,
  orientation: orientation,
  printinglocations: printinglocations,
  materials: materials,
  laminations: laminations,
  shapes: shapes,
  partners: partners,
  qty: qty,
  envelopes: envelopes,
  whychooseus: whychooseus,
  industry: industry,
  department: department,
  companysize: companysize,
  faqs: faqs,
  subfaq: subfaqSlice,
  socialmedia: socialmedia,
  coupons: coupons,
  privacyandpolicy: privacyandpolicy,
  returnpolicy: returnpolicy,
  termsandconditions:termsandconditions,
  careers:careers,
  blog_categories: blog_categories,
  blogs: blogs,
  sizes:sizes,
  help: help,
});

export default masters;
